'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

function formatIn(value) {
  if ((0, _lodash.isObject)(value) && !(0, _lodash.isNil)(value)) {
    return value.value;
  }
  return value;
}

// value为 ['1', '2', '3'] 类型的数组
// options 为未经过转换的 options
function formatOut(value, options) {
  if ((0, _lodash.isNil)(value)) {
    // 为空直接返回
    return value;
  } else if (!(0, _lodash.isEmpty)(value) && (0, _lodash.isObject)(value)) {
    // 不为空，且为对象，处理一下返回
    return {
      value: value.value,
      text: value.label || value.text || value.value
    };
  } else {
    // 不为空，且不为对象
    var result = { text: value, value: value };
    if (!(0, _lodash.isEmpty)(options)) {
      // 数据源不为空
      var selectOption = options.find(function (option) {
        return (0, _lodash.isEqual)(option.value, value);
      });
      return selectOption ? (0, _lodash.pick)(selectOption, ['text', 'value']) : result;
    } else {
      return result;
    }
  }
}

function defaultValueFormatter(value, state, options) {
  if ((0, _lodash.isNil)(value)) {
    return '';
  }
  if (!(0, _lodash.isEmpty)(options)) {
    var option = options.find(function (item) {
      return (0, _lodash.isObject)(value) ? item.value === value.value : item.value === value;
    });
    if (option) {
      return option.text || option.label;
    }
  }
  if ((0, _lodash.isObject)(value)) {
    return value.text || value.value;
  }
  return value;
}

function fieldDataFormatter(value, options, state) {
  var result = value;
  if ((0, _lodash.isObject)(value)) {
    result = options.find(function (item) {
      return item.value === value.value;
    });
  } else {
    result = options.find(function (item) {
      return item.value === value;
    });
  }
  return result || value;
}

exports.default = {
  formatIn: formatIn,
  formatOut: formatOut,
  defaultValueFormatter: defaultValueFormatter,
  fieldDataFormatter: fieldDataFormatter
};
module.exports = exports['default'];